// src/components/ui/LogRow.jsx — v8.7.1 POLISHED
// FIX 1: message парсинг — monitoring.js пишет "event | {json}"
//         Показываем только часть до " | {" — чистый текст
// FIX 2: timestamp autodetect ms vs sec

function parseTs(ts) {
  if (!ts) return null;
  const n = Number(ts);
  return n > 1e12 ? new Date(n) : new Date(n * 1000);
}

// Убираем JSON-хвост который мониторинг добавляет через formatMessage()
function cleanMessage(raw) {
  if (!raw) return "Log entry";
  // monitoring.js: `${message} | ${JSON.stringify(context)}`
  const pipeJson = raw.indexOf(" | {");
  if (pipeJson > -1) return raw.slice(0, pipeJson).trim();
  const pipeArr = raw.indexOf(" | [");
  if (pipeArr > -1) return raw.slice(0, pipeArr).trim();
  return raw;
}

export default function LogRow({ item }) {
  if (!item) return null;

  const level   = (item.level ?? "info").toLowerCase();
  const message = cleanMessage(item.message ?? item.source);
  const source  = item.source ?? item.origin ?? null;
  const dateObj = parseTs(item.timestamp);
  const ts      = dateObj
    ? dateObj.toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })
    : "—";

  const levelColor =
    level === "error" || level === "critical" ? "var(--danger)"  :
    level === "warning"                        ? "var(--warning)" :
                                                 "var(--text-muted)";

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "11px 20px" }}>
      <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--text-muted)", whiteSpace: "nowrap", width: 110, flexShrink: 0 }}>
        {ts}
      </div>
      <span style={{
        padding: "2px 7px", borderRadius: "var(--radius-sm)",
        border: `1px solid ${levelColor}40`,
        fontFamily: "var(--font-mono)", fontSize: 9,
        letterSpacing: "0.1em", color: levelColor,
        textTransform: "uppercase", flexShrink: 0,
        width: 54, textAlign: "center",
      }}>
        {level}
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        {source && (
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, color: "var(--text-muted)", letterSpacing: "0.08em", marginBottom: 2 }}>
            {source}
          </div>
        )}
        <div style={{ fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--text-secondary)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {message}
        </div>
      </div>
    </div>
  );
}
